import './chapter_menu.scss';
import { h } from 'preact';
import * as is from  'utilities/is';
import { BaseAnnotation } from '../base_annotation';
import { ChapterMenuBookmarks } from './chapter_menu_bookmarks';
import { secondsToTimecode } from 'utilities/formatting';
import { accessible } from 'utilities/accessibility';
import { ANNOTATION_EVENT, PLAYER_CONTROL_EVENT } from 'constants/events';
import { COMPOSITIONS, COMPOSITION_TYPES, ALL_STYLES, BEHAVIORS, STATES } from 'constants/annotations';
import { IoIosMenu } from 'react-icons/io'


export class ChapterMenuAnnotation extends BaseAnnotation {
    constructor(props) {
        super(props);
        this.state.expanded = (
            is.defined(this.state.expanded) ? 
                this.state.expanded : 
                this.options.expandedState === "collapsed" ?
                    false :
                    true
        )
    }

    onMenuClicked = event => {
        if (this.collapsible) {
            this.setState({
                expanded: !this.state.expanded
            });
        }
    } 

    componentDidUpdate(prevProps) {
        const { expanded } = this.state;
        const { expandedState } = this.options;

        if (expandedState === prevProps.properties?.expandedState) {
            return; 
        }

        const newChapterMenuState = expandedState === "collapsed" ? false : true;

        if (expandedState !== prevProps.properties?.expandedState && expanded !== newChapterMenuState) {
            this.setState({
                expanded: newChapterMenuState
            })
        }
    }

    onBookmarkClicked(bookmark) {
        this.eventBus.emit(ANNOTATION_EVENT.ANNOTATION_ACTION, 'Click', { ...this.props, bookmark });
        this.eventBus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, bookmark.start);
        this.eventBus.emit(PLAYER_CONTROL_EVENT.PLAY);
    }


    render () {
        const { CHAPTER_MENU } = COMPOSITION_TYPES,
            { showThumbnails = false } = this.options,
            { target, styles } = this.props;

        const bookmarkAttrs = {
            styles: styles,
            showThumbnails: showThumbnails,
            target: target,
            bookmarks: this.bookmarks,
            parentState: this.state,
            onBookmarkClicked: this.onBookmarkClicked.bind(this)
        }

        return (
            <div className="hapyak-contents-container" onClick={ this.onMenuClicked }>
                <div className={ this.classes } style={ this.getElementStyles() } { ...this.dataAttrs }>
                    <h3 className="popcorn-contents-title" { ...accessible(this.onMenuClicked) } style={ this.getElementStyles(CHAPTER_MENU.TITLE) }>
                        { this.content }
                        <div class="title-accent" style={ this.getElementStyles(CHAPTER_MENU.TITLE_ACCENT) }></div>
                    </h3>
                    <nav className="popcorn-contents-inner">
                        <ul className="popcorn-contents-hidden"></ul>
                        <ChapterMenuBookmarks {...bookmarkAttrs}/>
                    </nav>
                    <div className="popcorn-contents-more">
                        <div className="arrow-wide-down"></div>
                    </div>
                    <div aria-label="close" style={ this.getElementStyles(CHAPTER_MENU.CLOSE) } className="popcorn-contents-close" { ...accessible(this.onMenuClicked) }>×</div>
                </div>
            </div>
        );
    }

    get classes() {
        return `${super.classes} chapter-menu-annotation`;
    }

    get dataAttrs() {
        const {expanded } = this.state
        return {
            ...super.dataAttrs,
            "data-expanded": expanded ? expanded : "false",
            "data-content-empty": !expanded && !this.props.content, 
        }
    }

    get content() {
        return this.props.content || <IoIosMenu size="1.8em" />
    }

    get legacyClasses() {
        return [
            'popcorn-contents',
            'top-left',
            'active',
            (this.state.expanded ? 'expanded visible' : 'collapsed'),
            (this.options.mode ? `hapyak-contents-${this.options.mode}` : '')
        ].join(' ');
    }

    get collapsible() {
        return this.options.collapsible === 'false' || this.options.collapsible === false ? false : true;
    }

    static get composition() {
        return [
            { ...COMPOSITIONS.SIMPLE, STATES },
            ...Object
                .values(COMPOSITION_TYPES.CHAPTER_MENU)
                .map(v => ({
                    IDENTIFIER: v,
                    STYLES: ALL_STYLES,
                    BEHAVIORS: BEHAVIORS.CLICK,
                    STATES
                }))
        ];
    }

    static get schemaType() {
        return 'contents';
    }
}